export default {
  'search.placeholder': '请输入ID或者关键字获得帮助',
  'search.result': '搜索“{search}”，找到 {number} 个结果。',
  'no.search.results': '没有搜索结果。',
  'email.to.us': '把问题发送给我们。',
  'copy.success': '复制成功！',
  'copy.link': '复制链接'
}
